var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: "Album Management" },
        scopedSlots: _vm._u([
          {
            key: "button",
            fn: function() {
              return [
                _vm.isArtist
                  ? _c("Button", {
                      attrs: { variant: "primary", label: "Add Album" },
                      on: { clicked: _vm.toggleModal }
                    })
                  : _vm._e()
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _c(
                  "div",
                  {
                    staticClass: "pb-3 flex justify-between items-center w-full"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex flex-col items-center w-full" },
                      [
                        _c(
                          "el-row",
                          { staticClass: "w-full pb-3", attrs: { gutter: 10 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "search album name" },
                                  on: { change: _vm.searchAlbum },
                                  model: {
                                    value: _vm.filterAlbum,
                                    callback: function($$v) {
                                      _vm.filterAlbum = $$v
                                    },
                                    expression: "filterAlbum"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.isArtist
                              ? _c(
                                  "el-col",
                                  { attrs: { span: 8 } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "search artist name"
                                      },
                                      on: { change: _vm.searchAlbum },
                                      model: {
                                        value: _vm.filterArtist,
                                        callback: function($$v) {
                                          _vm.filterArtist = $$v
                                        },
                                        expression: "filterArtist"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isArtist
                              ? _c(
                                  "el-col",
                                  {
                                    staticClass: "flex flex-row",
                                    attrs: { span: 4 }
                                  },
                                  [
                                    _c("Button", {
                                      attrs: { label: "Apply" },
                                      on: { clicked: _vm.searchAlbum }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      { staticClass: "p-2" },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: ["fas", "sync"] },
                                          on: { click: _vm.resetAlbum }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { staticClass: "w-full pb-3", attrs: { gutter: 10 } },
                          [
                            !_vm.isArtist
                              ? _c(
                                  "el-col",
                                  {
                                    staticClass: "flex flex-row gap-3",
                                    attrs: { span: 24 }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "md:w-50 ",
                                        on: {
                                          click: function($event) {
                                            _vm.filterStatus = 0
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                                            class:
                                              _vm.filterStatus == 0
                                                ? "bg-indigo-500 text-gray-100"
                                                : ""
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "m-auto text-xs font-medium"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Waiting For Review (" +
                                                    _vm._s(
                                                      _vm.countWaitingForReviewAlbum
                                                    ) +
                                                    ")\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "md:w-40 ",
                                        on: {
                                          click: function($event) {
                                            _vm.filterStatus = 1
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                                            class:
                                              _vm.filterStatus == 1
                                                ? "bg-indigo-500 text-gray-100"
                                                : ""
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "m-auto text-xs font-medium"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Under Review (" +
                                                    _vm._s(
                                                      _vm.countUnderReviewAlbum
                                                    ) +
                                                    ")\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "md:w-40 ",
                                        on: {
                                          click: function($event) {
                                            _vm.filterStatus = 2
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                                            class:
                                              _vm.filterStatus == 2
                                                ? "bg-indigo-500 text-gray-100"
                                                : ""
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "m-auto text-xs font-medium"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Approved (" +
                                                    _vm._s(
                                                      _vm.countApprovedAlbum
                                                    ) +
                                                    ")\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "md:w-40 ",
                                        on: {
                                          click: function($event) {
                                            _vm.filterStatus = 3
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                                            class:
                                              _vm.filterStatus == 3
                                                ? "bg-indigo-500 text-gray-100"
                                                : ""
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "m-auto text-xs font-medium "
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Rejected (" +
                                                    _vm._s(
                                                      _vm.countRejectedAlbum
                                                    ) +
                                                    ")\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "md:w-40 ",
                                        on: {
                                          click: function($event) {
                                            _vm.filterStatus = 4
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                                            class:
                                              _vm.filterStatus == 4
                                                ? "bg-indigo-500 text-gray-100"
                                                : ""
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "m-auto text-xs font-medium "
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Published (" +
                                                    _vm._s(
                                                      _vm.countPublishedAlbum
                                                    ) +
                                                    ")\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "data-tables-server",
                  {
                    ref: "tableAlbum",
                    attrs: {
                      data: _vm.dataAlbum,
                      total: _vm.totalAlbum,
                      "pagination-props": { background: true, pageSizes: [6] }
                    },
                    on: { "query-change": _vm.onChangeAlbumTable }
                  },
                  [
                    _vm._l(_vm.titles, function(title) {
                      return _c("el-table-column", {
                        key: title.prop,
                        attrs: {
                          prop: title.prop,
                          label: title.label,
                          sortable: "custom"
                        }
                      })
                    }),
                    _vm._v(" "),
                    _vm.isArtist || _vm.isFinance || _vm.isRecruitment
                      ? _c("el-table-column", {
                          staticClass: "text-center",
                          attrs: { label: "Publish" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          scope.row.published
                                            ? "Published"
                                            : "Not Published"
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1068105525
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.isAdmin ||
                      _vm.isSuperAdmin ||
                      _vm.isOps ||
                      _vm.isRecruitment) &&
                    _vm.filterStatus !== 0 &&
                    _vm.filterStatus !== 1 &&
                    _vm.filterStatus !== 3
                      ? _c("el-table-column", {
                          staticClass: "text-center",
                          attrs: { label: "Publish", width: "100px" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "flex items-center",
                                        class: _vm.isEligiblePublished(
                                          scope.row
                                        )
                                          ? "cursor-pointer"
                                          : "cursor-not-allowed",
                                        staticStyle: { height: "50px" },
                                        attrs: { for: "toogle" + scope.row.id }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "relative m-auto" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: scope.row.published,
                                                  expression:
                                                    "scope.row.published"
                                                }
                                              ],
                                              staticClass: "hidden",
                                              attrs: {
                                                id: "toogle" + scope.row.id,
                                                type: "checkbox",
                                                disabled: !_vm.isEligiblePublished(
                                                  scope.row
                                                )
                                              },
                                              domProps: {
                                                checked: Array.isArray(
                                                  scope.row.published
                                                )
                                                  ? _vm._i(
                                                      scope.row.published,
                                                      null
                                                    ) > -1
                                                  : scope.row.published
                                              },
                                              on: {
                                                change: [
                                                  function($event) {
                                                    var $$a =
                                                        scope.row.published,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            scope.row,
                                                            "published",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            scope.row,
                                                            "published",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        scope.row,
                                                        "published",
                                                        $$c
                                                      )
                                                    }
                                                  },
                                                  function($event) {
                                                    return _vm.submitPublishedAlbum(
                                                      scope.row
                                                    )
                                                  }
                                                ]
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass:
                                                "toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                                            }),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass:
                                                "toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1479323752
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isFinance && !_vm.isRecruitment
                      ? _c("el-table-column", {
                          attrs: {
                            label: "Actions",
                            align: "right",
                            "min-width": "100px"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "static inline-block text-left container-action"
                                      },
                                      [
                                        _c(
                                          "VueCustomTooltip",
                                          {
                                            attrs: {
                                              label: "See Detail",
                                              position: "is-left"
                                            }
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "p-2 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.detail(
                                                      $event,
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass: "text-white",
                                                  attrs: { icon: ["fa", "eye"] }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.isArtist
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Edit",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "p-2 mr-2 rounded bg-yellow-500 hover:bg-yellow-600 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.edit(
                                                          $event,
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: [
                                                          "fa",
                                                          "pencil-alt"
                                                        ]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.canDelete &&
                                        (_vm.isSuperAdmin || _vm.isAdmin)
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Delete",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "p-2 mr-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.deleteAlbum(
                                                          $event,
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: [
                                                          "fa",
                                                          "trash-alt"
                                                        ]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.isArtist &&
                                        _vm.isEligibleUnderReview(scope.row)
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Set Under Review",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "p-2 w-8 mr-2 rounded bg-purple-400 hover:bg-purple-500 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.submitUnderReviewAlbum(
                                                          $event,
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: ["fa", "file-alt"]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        (_vm.isAdmin ||
                                          _vm.isSuperAdmin ||
                                          _vm.isOps ||
                                          _vm.isReviewer) &&
                                        scope.row.statusCode == 2
                                          ? _c(
                                              "VueCustomTooltip",
                                              {
                                                attrs: {
                                                  label: "Add Tags",
                                                  position: "is-left"
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "p-2 w-8 rounded bg-green-400 hover:bg-green-500 focus:outline-none",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.addTags(
                                                          scope.row
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "text-white",
                                                      attrs: {
                                                        icon: ["fa", "tags"]
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            997058147
                          )
                        })
                      : _vm._e()
                  ],
                  2
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          attrs: {
            isShowingModal: _vm.isShowingModalEdit,
            isLoading: _vm.isLoading,
            labelSubmit: "Save",
            title: "Edit Album Details"
          },
          on: {
            toggleModal: function($event) {
              return _vm.toggleModalEdit()
            },
            save: function($event) {
              return _vm.submitForUpdate()
            }
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("EditAlbum", {
                ref: "editAlbumContent",
                attrs: {
                  "toggle-reset": _vm.isShowingModalEdit,
                  "album-id": _vm.idAlbum,
                  "musicverse-cut": _vm.getUser.musicverse_cut,
                  "artist-cut": _vm.getUser.artist_cut
                },
                on: { "on-edit-album": _vm.onSubmitEditAlbum }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          attrs: {
            isShowingModal: _vm.isShowingModal,
            isLoading: _vm.isLoading,
            title: "Add Album Details"
          },
          on: {
            toggleModal: function($event) {
              return _vm.toggleModal()
            },
            save: function($event) {
              return _vm.submitForReview()
            }
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("AddAlbum", {
                ref: "addAlbumContent",
                attrs: {
                  "toggle-reset": _vm.isShowingModal,
                  "musicverse-cut": _vm.getUser.musicverse_cut,
                  "artist-cut": _vm.getUser.artist_cut
                },
                on: { "on-submit-album": _vm.onSubmitAlbum }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          attrs: {
            isShowingModal: _vm.isShowingModalListSong,
            isLoading: _vm.isLoading,
            title: "Add Song to Album",
            labelSubmit: "Add to Album"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingModalListSong = !_vm.isShowingModalListSong
            },
            save: _vm.addToAlbum
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                "data-tables",
                {
                  attrs: {
                    data: _vm.dataSong,
                    total: _vm.totalSong,
                    "pagination-props": { pageSizes: [6] }
                  },
                  on: { "selection-change": _vm.handleSelectionChange }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.titleSong, function(title) {
                    return _c("el-table-column", {
                      key: title.prop,
                      attrs: {
                        prop: title.prop,
                        label: title.label,
                        sortable: "custom"
                      }
                    })
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Song", width: "250px" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "audio",
                              {
                                staticClass: "audio-player",
                                staticStyle: { width: "240px" },
                                attrs: {
                                  controls: "",
                                  src: scope.row.file,
                                  id: "audioPlayer" + scope.row.id,
                                  controlsList: "nodownload",
                                  type: "audio/mp3",
                                  preload: "none"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              Audio tag not supported\n            "
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          attrs: {
            isShowingModal: _vm.isShowingModalListSongEdit,
            isLoading: _vm.isLoading,
            title: "Add Song to Album",
            labelSubmit: "Add to Album"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingModalListSongEdit = !_vm.isShowingModalListSongEdit
            },
            save: _vm.addToAlbumEdit
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                "data-tables",
                {
                  attrs: {
                    data: _vm.dataSong,
                    total: _vm.totalSong,
                    "pagination-props": { pageSizes: [6] }
                  },
                  on: { "selection-change": _vm.handleSelectionChange }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.titleSong, function(title) {
                    return _c("el-table-column", {
                      key: title.prop,
                      attrs: {
                        prop: title.prop,
                        label: title.label,
                        sortable: "custom"
                      }
                    })
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "Song", width: "250px" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "audio",
                              {
                                staticClass: "audio-player",
                                staticStyle: { width: "240px" },
                                attrs: {
                                  controls: "",
                                  src: scope.row.file,
                                  id: "audioPlayer" + scope.row.id,
                                  controlsList: "nodownload",
                                  type: "audio/mp3",
                                  preload: "none"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              Audio tag not supported\n            "
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ModalDialogDetail",
        {
          attrs: {
            isShowingModal: _vm.isShowingModalDetail,
            isLoading: _vm.isLoading,
            title: "Album Details",
            size: "xlarge"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingModalDetail = !_vm.isShowingModalDetail
            }
          }
        },
        [
          _c("template", { slot: "body" }, [
            _c("div", { staticClass: "flex items-start gap-20 mb-3 pt-4" }, [
              _c(
                "div",
                { staticClass: "flex w-2/5 flex-col items-center px-3" },
                [
                  _c(
                    "div",
                    { staticClass: "flex-1 flex flex-col md:flex-row pb-4" },
                    [
                      _c("div", { staticClass: "w-full flex-1 mx-2" }, [
                        _c("div", { staticClass: "my-2 p-1 flex" }, [
                          _c("img", {
                            attrs: { src: _vm.album.cover, width: "200px" }
                          })
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  (_vm.isAdmin ||
                    _vm.isSuperAdmin ||
                    _vm.isOps ||
                    _vm.isReviewer) &&
                  _vm.album.status === 1
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col md:flex-row border-b border-gray-200 pb-4"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "w-64 font-bold h-auto mt-3 text-gray-800 flex flex-row"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "text-sm  mx-2 w-full  focus:outline-none flex justify-center px-4 py-2 rounded font-bold cursor-pointer\n                        bg-green-400 hover:bg-green-500\n                        text-white\n                           transition",
                                  on: {
                                    click: function($event) {
                                      return _vm.submitApprovalAlbum(
                                        _vm.album.id,
                                        true
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Approve\n                ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "text-sm  mx-2 w-full text-white focus:outline-none flex justify-center px-4 py-2 rounded font-bold cursor-pointer bg-red-700 hover:bg-red-800 transition mx-2",
                                  on: {
                                    click: function($event) {
                                      return _vm.submitApprovalAlbum(
                                        _vm.album.id,
                                        false
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Reject\n                ")]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "flex w-full py-4" }, [
                _c(
                  "div",
                  { staticClass: "w-1/2" },
                  [
                    _c("form-item", {
                      attrs: { label: "Album Name" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(_vm._s(_vm.album.name))
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    !_vm.isArtist
                      ? _c("form-item", {
                          attrs: { label: "Artist Name" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function() {
                                  return [
                                    _c(
                                      "p",
                                      { staticClass: "text-left font-bold" },
                                      [_vm._v(_vm._s(_vm.album.artist))]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            30863674
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Year" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(_vm._s(_vm.album.year))
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Language" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(_vm._s(_vm.album.language))
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Composer" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(_vm._s(_vm.album.composer || "-"))
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "w-1/2" },
                  [
                    _c("form-item", {
                      attrs: { label: "Subscription" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.album.is_subscription == 0
                                      ? "No"
                                      : "Yes"
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Sell Song Individually" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.album.sell_song_individually == 0
                                      ? "No"
                                      : "Yes"
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Paid Album" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", { staticClass: "text-left font-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.album.is_paid == 0 ? "Free" : "Paid"
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm.album.is_paid == 1
                      ? _c("form-item", {
                          attrs: { label: "Album Price (USD)" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function() {
                                  return [
                                    _c(
                                      "p",
                                      { staticClass: "text-left font-bold" },
                                      [
                                        _vm._v(
                                          "$ " +
                                            _vm._s(
                                              parseFloat(
                                                _vm.toDollar(_vm.album.price)
                                              ).toFixed(2)
                                            ) +
                                            "    = " +
                                            _vm._s(
                                              parseFloat(
                                                _vm.album.price
                                              ).toFixed(2)
                                            ) +
                                            " Credits"
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            3521361570
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Copyright" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              !!_vm.album.copyright
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "underline text-left font-bold",
                                      attrs: {
                                        href: _vm.album.copyright,
                                        target: "_blank"
                                      }
                                    },
                                    [_vm._v("Copyright Link")]
                                  )
                                : _c(
                                    "p",
                                    { staticClass: "text-left font-bold" },
                                    [_vm._v("-")]
                                  )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "px-2" },
              [
                _c(
                  "data-tables",
                  {
                    attrs: {
                      layout: "table",
                      data: _vm.dataDetailSong,
                      total: _vm.dataDetailSong.length,
                      "pagination-props": { pageSizes: [100] }
                    },
                    on: { "selection-change": _vm.handleSelectionChange }
                  },
                  [
                    _vm._l(_vm.titleDetailSong, function(title) {
                      return _c("el-table-column", {
                        key: title.prop,
                        attrs: {
                          prop: title.prop,
                          label: title.label,
                          sortable: "custom"
                        }
                      })
                    }),
                    _vm._v(" "),
                    _vm.isAdmin ||
                    _vm.isSuperAdmin ||
                    _vm.isOps ||
                    _vm.isRecruitment
                      ? _c("el-table-column", {
                          staticClass: "text-center",
                          attrs: { label: "Publish", width: "90px" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "label",
                                      {
                                        staticClass: "flex items-center",
                                        class: _vm.isEligiblePublished(
                                          scope.row
                                        )
                                          ? "cursor-pointer"
                                          : "cursor-not-allowed",
                                        staticStyle: { height: "50px" },
                                        attrs: { for: "toogle" + scope.row.id }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "relative m-auto" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: scope.row.published,
                                                  expression:
                                                    "scope.row.published"
                                                }
                                              ],
                                              staticClass: "hidden",
                                              attrs: {
                                                id: "toogle" + scope.row.id,
                                                type: "checkbox",
                                                disabled: !_vm.isEligiblePublished(
                                                  scope.row
                                                )
                                              },
                                              domProps: {
                                                checked: Array.isArray(
                                                  scope.row.published
                                                )
                                                  ? _vm._i(
                                                      scope.row.published,
                                                      null
                                                    ) > -1
                                                  : scope.row.published
                                              },
                                              on: {
                                                change: [
                                                  function($event) {
                                                    var $$a =
                                                        scope.row.published,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            scope.row,
                                                            "published",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            scope.row,
                                                            "published",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        scope.row,
                                                        "published",
                                                        $$c
                                                      )
                                                    }
                                                  },
                                                  function($event) {
                                                    return _vm.submitPublished(
                                                      scope.row
                                                    )
                                                  }
                                                ]
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass:
                                                "toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                                            }),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass:
                                                "toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4170694975
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "Song", width: "250px" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "audio",
                                {
                                  staticClass: "audio-player",
                                  staticStyle: { width: "240px" },
                                  attrs: {
                                    controls: "",
                                    src: scope.row.file,
                                    id: "audioPlayer" + scope.row.id,
                                    controlsList: "nodownload",
                                    type: "audio/mp3",
                                    preload: "none"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Audio tag not supported\n              "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: "Actions",
                        align: "right",
                        width: "150px"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "static flex items-center justify-end text-left container-action"
                                },
                                [
                                  _c(
                                    "VueCustomTooltip",
                                    {
                                      attrs: {
                                        label: "Add Lyrics",
                                        position: "is-left"
                                      }
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "p-2 w-8 mr-2 rounded bg-blue-600 hover:bg-blue-600 focus:outline-none",
                                          on: {
                                            click: function($event) {
                                              return _vm.addLyrics(scope.row)
                                            }
                                          }
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: { height: "22px" },
                                            attrs: {
                                              src: require("@/assets/lyrics.svg")
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  !_vm.isArtist
                                    ? _c(
                                        "VueCustomTooltip",
                                        {
                                          attrs: {
                                            label: "Set Under Review",
                                            position: "is-left"
                                          }
                                        },
                                        [
                                          _vm.isEligibleUnderReview(scope.row)
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "p-2 w-8 mr-2 rounded bg-purple-400 hover:bg-purple-500 focus:outline-none",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.submitUnderReview(
                                                        $event,
                                                        scope.row
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    staticClass: "text-white",
                                                    attrs: {
                                                      icon: ["fa", "file-alt"]
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.isArtist
                                    ? _c(
                                        "VueCustomTooltip",
                                        {
                                          attrs: {
                                            label: "Approve",
                                            position: "is-left"
                                          }
                                        },
                                        [
                                          _vm.isEligibleApproved(scope.row)
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "p-2 mr-2 w-8 rounded bg-green-400 hover:bg-green-500 focus:outline-none",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.submitApproved(
                                                        $event,
                                                        scope.row
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    staticClass: "text-white",
                                                    attrs: {
                                                      icon: ["fa", "check"]
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.isArtist
                                    ? _c(
                                        "VueCustomTooltip",
                                        {
                                          attrs: {
                                            label: "Reject",
                                            position: "is-left"
                                          }
                                        },
                                        [
                                          _vm.isEligibleRejected(scope.row)
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "p-2 w-8 rounded bg-red-700 hover:bg-red-800 focus:outline-none",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.showingRejectModal(
                                                        $event,
                                                        scope.row
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    staticClass: "text-white",
                                                    attrs: {
                                                      icon: ["fa", "times"]
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  (_vm.isAdmin ||
                                    _vm.isSuperAdmin ||
                                    _vm.isOps ||
                                    _vm.isReviewer) &&
                                  scope.row.statusCode == 2
                                    ? _c(
                                        "VueCustomTooltip",
                                        {
                                          attrs: {
                                            label: "Add Tags",
                                            position: "is-left"
                                          }
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "p-2 w-8 rounded bg-green-400 hover:bg-green-500 focus:outline-none",
                                              on: {
                                                click: function($event) {
                                                  return _vm.addTagsSong(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                staticClass: "text-white",
                                                attrs: { icon: ["fa", "tags"] }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  2
                )
              ],
              1
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          ref: "submissionRejection",
          attrs: {
            isShowingModal: _vm.isShowingModalReject,
            isLoading: _vm.isLoading,
            error: _vm.isError,
            labelSubmit: "Submit Rejection",
            title: "Reject Submission"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingModalReject = !_vm.isShowingModalReject
            },
            save: function($event) {
              return _vm.submitRejected(_vm.songRejection)
            }
          }
        },
        [
          _c("template", { slot: "body" }, [
            _c("form", [
              _c("div", { staticClass: "w-full" }, [
                _c("div", { staticClass: "flex flex-wrap -mx-3 mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "w-1/4 md:w-1/4 px-3 mb-3 md:mb-0" },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2",
                          attrs: { for: "grid-name-music" }
                        },
                        [_vm._v("\n                Note\n              ")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "w-3/4 md:w-3/4 px-5 mb-3 md:mb-0" },
                    [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.songRejection.note,
                            expression: "songRejection.note"
                          }
                        ],
                        staticClass:
                          "appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white",
                        attrs: {
                          id: "grid-name-music",
                          type: "text",
                          placeholder: "Note for Rejection",
                          autocomplete: "off"
                        },
                        domProps: { value: _vm.songRejection.note },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.songRejection,
                              "note",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]
                  )
                ])
              ])
            ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          ref: "addTags",
          attrs: {
            isShowingModal: _vm.isShowingModalTags,
            isLoading: _vm.isLoading,
            error: _vm.isError,
            labelSubmit: "Save",
            title: "Add Tags"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingModalTags = false
            },
            save: function($event) {
              return _vm.submitTags()
            }
          }
        },
        [
          _c("template", { slot: "body" }, [
            _c(
              "div",
              { staticClass: "w-full py-4" },
              [
                _c(
                  "form-item",
                  { attrs: { label: "Tags" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "w-full",
                        attrs: {
                          multiple: "",
                          filterable: "",
                          remote: "",
                          "allow-create": "",
                          "default-first-option": "",
                          "reserve-keyword": "",
                          size: "large",
                          placeholder: "Please enter a keyword",
                          "remote-method": _vm.searchTags,
                          loading: _vm.loadingTags
                        },
                        model: {
                          value: _vm.tagsValue,
                          callback: function($$v) {
                            _vm.tagsValue = $$v
                          },
                          expression: "tagsValue"
                        }
                      },
                      _vm._l(_vm.tagsOption, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          ref: "addTagsSong",
          attrs: {
            isShowingModal: _vm.isShowingModalTagsSong,
            isLoading: _vm.isLoading,
            error: _vm.isError,
            labelSubmit: "Save",
            title: "Add Tags Song"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingModalTagsSong = false
            },
            save: function($event) {
              return _vm.submitTagsSong()
            }
          }
        },
        [
          _c("template", { slot: "body" }, [
            _c(
              "div",
              { staticClass: "w-full py-4" },
              [
                _c(
                  "form-item",
                  { attrs: { label: "Tags" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "w-full",
                        attrs: {
                          multiple: "",
                          filterable: "",
                          remote: "",
                          "allow-create": "",
                          "default-first-option": "",
                          "reserve-keyword": "",
                          size: "large",
                          placeholder: "Please enter a keyword",
                          "remote-method": _vm.searchTagsSong,
                          loading: _vm.loadingTagsSong
                        },
                        model: {
                          value: _vm.tagsValueSong,
                          callback: function($$v) {
                            _vm.tagsValueSong = $$v
                          },
                          expression: "tagsValueSong"
                        }
                      },
                      _vm._l(_vm.tagsOptionSong, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ModalDialog",
        {
          ref: "modalAddLyrics",
          attrs: {
            isShowingModal: _vm.isShowingModalLyrics,
            isLoading: _vm.isLoading,
            error: _vm.isError,
            labelSubmit: "Upload Lyrics",
            title: _vm.musicLyrics.lyrics ? "Replace Lyric" : "Add Lyric"
          },
          on: {
            toggleModal: function($event) {
              _vm.isShowingModalLyrics = !_vm.isShowingModalLyrics
            },
            save: _vm.uploadLyrics
          }
        },
        [
          _c("template", { slot: "body" }, [
            _c("form", { staticClass: "p-8" }, [
              _c(
                "div",
                { staticClass: "w-full" },
                [
                  _c("form-item", { attrs: { label: "Upload Lyrics" } }, [
                    !_vm.musicLyrics.lyricsFile
                      ? _c("input", {
                          staticClass:
                            "block border border-grey-light w-full p-3 rounded",
                          attrs: {
                            type: "file",
                            name: "copyright_file",
                            accept: ".srt"
                          },
                          on: { change: _vm.onFileLyricsChanged }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.musicLyrics.lyricsFile
                      ? _c("div", { staticClass: "flex" }, [
                          _c(
                            "span",
                            { staticClass: "mr-2 text-gray-700 font-medium" },
                            [_vm._v(_vm._s(_vm.musicLyrics.lyricsFile.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            { on: { click: _vm.changeFileLyrics } },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "times-circle"] }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col pt-2" },
                      [
                        _vm.musicLyrics.errorSrt
                          ? _c("text-error", {
                              attrs: { text: "File type must be srt." }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62547525", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62547525","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Album.vue
// module id = null
// module chunks = 